export default {
  methods: {
    showModal(component, parameters = {}, options = {}, events = {}) {
      const defaultOptions = {
        height: 'auto',
        width: '80%',
        classes: ['v--modal'],
        transition: 'spin-out',
      };
      this.$modal.show(component, parameters, Object.assign({}, defaultOptions, options), events);
    },
    hideModal() {
      this.$modal.hide();
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/modal-mixins.js